<div
  class="border border-outline dark:border-outline-darkmode rounded-lg py-5 px-6 flex flex-col gap-5 h-full w-full"
>
  <div class="flex items-center gap-2">
    <ui-skeleton class="flex-1 inline-block h-4 w-40 rounded-full" />

    <ui-skeleton class="w-[78px] inline-block h-10 rounded-lg" />
  </div>
  <div class="text-end">
    <div class="flex justify-end items-end h-10">
      <ui-skeleton class="inline-block h-9 w-40 rounded-full" />
      <ui-skeleton class="ml-1 inline-block h-5 w-10 rounded-full" />
    </div>
  </div>
</div>
